import {useEffect} from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import DecodeToken from '../../../utils/decode-token';  
import getRoleRedirectPath from '../../../utils/role-redirect';
import { clearSession } from '../../../utils/auth';
const AutoLogin = () => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();

    useEffect(() => {
        const token = searchParams.get('token')


        if(!token) {
            clearSession();
            navigate('/login');
            return;
        }
        try{
            const decoded = DecodeToken(token); 
            if (!decoded.exp || Date.now() / 1000 >= decoded.exp) {
            clearSession();
            navigate('/login');
            return;
        }
            sessionStorage.setItem('token',token);
            navigate(getRoleRedirectPath(decoded.role));

        }catch{
            clearSession();
            navigate('/login');
        }
    },[])// [] → solo se ejecuta al montar, no en cada render
    
    return null
};

export default AutoLogin;